import React, { createContext, useContext, useState } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { Experiment } from '@amplitude/experiment-js-client'

export const ExperimentContext = createContext()

export default function ExperimentProvider({ children }) {
  const [experiment, setExperiment] = useState(null)

  const initExperiment = async () => {
    const exp = Experiment.initializeWithAmplitudeAnalytics(
      process.env.NEXT_PUBLIC_AMPLITUDE_DEPLOYMENT_KEY
    )
    await exp.fetch()
    setExperiment(exp)
  }

  /**
   * Usage:
   *  import { useExperimentContext } from '../ExperimentProvider'
   *
   *  const { getVariant } = useExperimentContext()
   *  const variant = getVariant('test-implementation')
   *
   * {variant ? variant.payload.data.message : 'title text'}
   *
   * @param {string} key
   * @returns
   */
  const getVariant = (key) => {
    if (!experiment) return null
    const variant = experiment.variant(key)
    return variant
  }

  useIsomorphicLayoutEffect(() => {
    initExperiment()
  }, [])

  return (
    <ExperimentContext.Provider value={{ getVariant }}>
      {children}
    </ExperimentContext.Provider>
  )
}

export function useExperimentContext() {
  return useContext(ExperimentContext)
}
